/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { IBrandSafetyRule } from '~/src/dash/api/brand-safety-rules';
import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';
import { ct } from '~/src/dash/publicaUI';

export const ChipTypeUndefined = createChipWihFadingBackgroundVariations(
  '#7e7e7e',
  'rgba(126,126,126,0.1)',
  'rgba(126,126,126,0.05)',
  'rgba(126,126,126,0.15)',
);
export const ChipTypeIAB = createChipWihFadingBackgroundVariations(
  '#F0072C',
  'rgba(255,5,5,0.10)',
  'rgba(255,5,5,0.05)',
  'rgba(255,5,5,0.15)',
);
export const ChipTypeAdomain = createChipWihFadingBackgroundVariations(
  '#8749ff',
  'rgba(135,73,255,0.10)',
  'rgba(135,73,255,0.01)',
  'rgba(135,73,255,0.15)',
);
export const ChipTypeMediafile = createChipWihFadingBackgroundVariations(
  '#078ff0',
  'rgba(5,151,255,0.10)',
  'rgba(5,151,255,0.01)',
  'rgba(5,151,255,0.15)',
);
export const ChipTypeLanguage = createChipWihFadingBackgroundVariations(
  '#10C700',
  'rgba(175, 253, 185, 0.4)',
  'rgba(175, 253, 185, 0.4)',
  'rgba(175, 253, 185, 0.4)',
);

export const ChipTypeCreativeID = createChipWihFadingBackgroundVariations(
  '#f0c507',
  'rgba(240, 197, 7,0.10)',
  'rgba(240, 197, 7,0.01)',
  'rgba(240, 197, 7,0.15)',
);

export const getRuleTypeChip = (rule: IBrandSafetyRule): Record<string, any> => {
  if (rule.TargetedIABs !== '') {
    return { component: ChipTypeIAB, label: ct('IAB') };
  }
  if (rule.TargetedAdomains !== '') {
    return { component: ChipTypeAdomain, label: ct('Adomain') };
  }
  if (rule.TargetedMediafiles !== '') {
    return { component: ChipTypeMediafile, label: ct('Mediafile') };
  }
  if (rule.TargetedCreativeIDs !== '') {
    return { component: ChipTypeCreativeID, label: ct('CreativeID') };
  }
  if (rule.TargetedLanguages !== '') {
    return { component: ChipTypeLanguage, label: ct('Language') };
  }
  return { component: ChipTypeUndefined, label: ct('Unknown') };
};
